// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"Y4-z"};